module.exports = __webpack_public_path__ + "img/news-left.b64ed6c2.png";